/* eslint-disable */
const localization = {
    // This is the array of lexemes found in the app
    lexemes: [
      "Descargar en App Store",
      "Conoce en persona a grupos de tu zona",
      "Conecta con tu gente en Hives",
      "Encontrá a tu comunidad",
      "Sea cual sea tu pasión, ¡hay una Hive para ti!",
      "Un espacio seguro para ser tú",
      "Elige entre Hives ocultas o visibles.",
      "Empezar",
      "Sea cual sea tu pasión, hay una Hive para ti",
      "Descubrí gente nueva en las Hives de Bumble BFF",
      "Te invitaron a Hives",
      "Encontrá nuevos grupos de locales con la nueva función de Bumble BFF, Hives. Creá tu perfil de BFF en la app de Bumble ya.",
      "Descargar en Google Play",
      "Gestionar cookies",
      "Gender Pay Gap",
      "Modern Slavery Statement",
      "Terms and Conditions",
      "About",
      "Life"
],

    // These are the common words found in the lexemes of the app
    common: {
      "day": {
            "plural": [
                  "días"
            ],
            "singular": [
                  "día"
            ]
      },
      "hour": {
            "plural": [
                  "horas"
            ],
            "singular": [
                  "hora"
            ]
      },
      "minute": {
            "plural": [
                  "minutos"
            ],
            "singular": [
                  "minuto"
            ]
      },
      "month": {
            "plural": [
                  "meses"
            ],
            "singular": [
                  "mes"
            ]
      },
      "second": {
            "plural": [
                  "segundos"
            ],
            "singular": [
                  "segundo"
            ]
      },
      "year": {
            "plural": [
                  "años"
            ],
            "singular": [
                  "año"
            ]
      }
}
};

// In dev mode we extend lexemes to include the indexMap as well, in production it remains as an array
if (__DEV__) {
    // This is a map of lexeme ids to their index in the array, it's only needed during development
    const indexMap = require('./index-map').default;

    localization.indexMap = indexMap;

    Object.entries(localization.indexMap).forEach(([indexKey, indexValue]) => {
        localization.lexemes[indexKey] = localization.lexemes[indexValue];
    });
}

export default localization;
